import React, { useRef, useEffect, useState, useCallback } from "react";
import { faCheck, faTimes, faInfoCircle, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Col, Container, Form, Row } from "react-bootstrap";
import "./UserRegistration.css";
import useAuth from "../../hooks/useAuth";
// import Select from 'react-select';
import { fetchPranthList } from './pranthService'; // Adjust path as needed
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const NAME_REGEX = /^(?!\s*$).+/;
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const MOBILE_REGEX = /^[0-9]{10}$/;
const PASSWORD_REGEX = /^.{6,}$/;
const REGISTER_URL = "admin/create-user";


const AdminAddUser = () => {
  const back = async (e) => {
    e.preventDefault();
    // setSuccess(false);
    setMobile("");
  };
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();
  const userRef = useRef();
  const errRef = useRef();
  const [mobile, setMobile] = useState("");
  const [name, setName] = useState("");
  const [responsibility, setResponsibility] = useState("");
  const [otpData, setOtpData] = useState(null); // To store second API result
  const [error, setError] = useState(null);
  const [validMobile, setValidMobile] = useState(false);
  const [validName, setValidName] = useState(false);

  const [mobileFocus, setMobileFocus] = useState(false);
  const [nameFocus, setNameFocus] = useState(false);
  const [responsibilityFocus, setResponsibilityFocus] = useState(false);
  const { auth } = useAuth();
  const [selectedArthikSakhaId, setSelectedArthikSakhaId] = useState(auth?.level_id); // default value
  const [pranthList, setPranthList] = useState([]);

  const [mandalamList, setMandalamList] = useState([]);
  const [selectedMandalamId, setSelectedMandalamId] = useState("");

  const [sthanList, setSthanList] = useState([]);
  const [selectedSthanId, setSelectedSthanId] = useState("");

  const [errMsg, setErrMsg] = useState("");
  const [sucssMsg, setSucssMsg] = useState("");
  // const [success, setSuccess] = useState(false);
  const [selectedRole, setSelectedRole] = useState("");

  const [khandList, setKhandList] = useState([]);
  const [selectedKhandId, setSelectedKhandId] = useState("");
  const [selectedPranthId, setSelectedPranthId] = useState(1);
  const [arthiksakhasList, setArthiksakhasList] = useState([]);
  const [selectedArthiksakhasId, setSelectedArthiksakhasId] = useState("");


  const [selectedVibhagId, setSelectedVibhagId] = useState("");
  const [vibhagList, setVibhagList] = useState([]);

  const [selectedJillaId, setSelectedJillaId] = useState("");
  const [jillaList, setJillaList] = useState([]);

  const [Sthans, setSthans] = useState([]);
  const [loading, setLoading] = useState(true);

  const [errors, setErrors] = useState({});

  useEffect(() => {
    setSelectedVibhagId("");
    setSelectedJillaId("");
    setSelectedKhandId("");
    setSelectedMandalamId("");
    setSelectedSthanId("");
    setSelectedArthiksakhasId("");

    setJillaList([]);
    setKhandList([]);
    setMandalamList([]);
    setSthanList([]);
  }, [selectedRole]);

  useEffect(() => {
    if (selectedPranthId) {
      fetchVibhagList(selectedPranthId).then((vibhags) => {
        if (vibhags.length > 0) {

        } else {
          setSelectedVibhagId("");
          setVibhagList([]);
          setSelectedJillaId("");
          setJillaList([]);
          setSthans([]);
          setKhandList([]);              // ✅ Add this line
          setSelectedKhandId("");        // ✅ Add this line
          setMandalamList([]);              // ✅ Add this line
          setSelectedMandalamId("");        // ✅ Add this line
          setError("No vibhags for selected pranth");
        }
      });
    }
  }, [selectedPranthId]);

  const fetchJillaList = useCallback(async () => {
    try {
      const res = await axiosPrivate.get(`list-jillas?vibhag_id=${selectedVibhagId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setJillaList(data);
    } catch (err) {
      console.error("Jilla fetch failed:", err);
      setError("Failed to load jilla list");
      setJillaList([]);
      setSelectedJillaId("");
    }
  }, [axiosPrivate, selectedVibhagId]);

  useEffect(() => {
    if (selectedVibhagId) {
      fetchJillaList();
    }
  }, [selectedVibhagId]);

  const fetchVibhagList = async (pranthId) => {
    try {
      const res = await axiosPrivate.get(`list-vibhags?pranth_id=${pranthId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setVibhagList(data);
      return data;
    } catch (err) {
      console.error("Failed to fetch vibhags", err);
      setVibhagList([]);
      return [];
    }
  };



  useEffect(() => {
    userRef.current.focus();
  }, []);


  useEffect(() => {
    const isValid = /^[0-9]{10}$/.test(mobile);
    setValidMobile(isValid);
  }, [mobile]);

  useEffect(() => {
    const isValid = /^[a-zA-Z\s]{2,}$/.test(name); // At least 2 letters, only letters & spaces
    setValidName(isValid);
  }, [name]);

  const clearFields = async () => {
    setSelectedRole("");
    setSelectedVibhagId("");
    setSelectedJillaId("");
    setSelectedArthiksakhasId("");
    setSelectedKhandId("");        // ✅ Add this line
    setSelectedMandalamId("");        // ✅ Add this line
    setSelectedSthanId("")

    setName("");
    setMobile("");
    setResponsibility("");
  };


  useEffect(() => {
    const getPranths = async () => {
      const data = await fetchPranthList(); // Get data from the service
      setPranthList(data);                  // Set data to state
    };

    getPranths();
  }, []);

  useEffect(() => {
    fetchPranthList();
  }, []);


  const fetchArthiksakhaList = async (pranthId) => {
    try {
      const res = await axiosPrivate.get(`list-arthik-sakhas?pranth_id=${pranthId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setArthiksakhasList(data);
      return data;
    } catch (err) {
      console.error("Failed to fetch Arthiksakha", err);
      setArthiksakhasList([]);
      return [];
    }
  };

  useEffect(() => {
    if (selectedPranthId) {
      fetchArthiksakhaList(selectedPranthId).then((vibhags) => {
        if (vibhags.length > 0) {
          setSelectedArthiksakhasId(vibhags[0].vibhag_id);
        } else {
          setSelectedArthiksakhasId("");
          setArthiksakhasList([]);
          setSthans([]);
          setKhandList([]);              // ✅ Add this line
          setSelectedKhandId("");        // ✅ Add this line
          setMandalamList([]);              // ✅ Add this line
          setSelectedMandalamId("");        // ✅ Add this line
          // setError("No vibhags for selected pranth");
        }
      });
    }
  }, [selectedPranthId]);


  const fetchKhands = useCallback(async () => {
    if (!selectedJillaId) return;

    setLoading(true);
    setSthans([]);
    try {
      const res = await axiosPrivate.get(`list-khands?jilla_id=${selectedJillaId}`);
      const data = Array.isArray(res.data) ? res.data : [];

      setKhandList(data);
      setSelectedKhandId("");

    } catch (err) {
      console.error("Khand fetch failed:", err);
      setError("Failed to load Khand list");
      setKhandList([]);
      setSelectedKhandId("");
    }
    // finally {
    //   setLoading(false);
    // }
  }, [axiosPrivate, selectedJillaId]);

  useEffect(() => {
    if (selectedJillaId) {
      fetchKhands();
    }
  }, [selectedJillaId]);

  useEffect(() => {
    const fetchMandalamList = async () => {
      if (!selectedKhandId) {
        setMandalamList([]);
        setSelectedMandalamId("");
        setSthans([]); // clear table
        return;
      }

      // setLoading(true);
      try {
        const res = await axiosPrivate.get(`list-mandals?khand_id=${selectedKhandId}`);
        const data = Array.isArray(res.data) ? res.data : [];
        setMandalamList(data);
        setMandalamList(data);
        setSelectedMandalamId(""); // Keep nothing selected

        if (data.length === 0) {
          setSthans([]);
        }

      } catch (err) {
        console.error("mandals fetch failed:", err);
        setError("Failed to load mandals list");
        setMandalamList([]);
        setSelectedMandalamId("");
        setSthans([]);
      }
      // finally {
      //   setLoading(false);
      // }
    };

    fetchMandalamList();
  }, [selectedKhandId]);



  useEffect(() => {
    const fetchSthanList = async () => {
      if (!selectedMandalamId) {
        setSthanList([]);
        setSelectedSthanId("");
        setSthans([]);
        return;
      }

      try {
        const res = await axiosPrivate.get(
          `list-sthans?mandal_id=${selectedMandalamId}`
        );

        const data = Array.isArray(res.data) ? res.data : [];

        setSthanList(data);

        // Clear only the Sthan selection
        setSelectedSthanId("");

        if (data.length === 0) {
          setSthans([]);
        }
      } catch (err) {
        console.error("Sthan fetch failed:", err);
        setError("Failed to load Sthan list");
        setSthanList([]);
        setSelectedSthanId("");
        setSthans([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSthanList();
  }, [selectedMandalamId]);

  const validateForm = () => {
    const newErrors = {};

    if (!selectedRole) newErrors.role = "Please select a role.";
    if (!selectedPranthId) newErrors.pranth = "Please select a Pranth.";

    if (selectedRole !== "Arthiksakha" && !selectedVibhagId)
      newErrors.vibhag = "Please select a Vibhag.";

    if (["Jilla", "Khand", "Sthan"].includes(selectedRole) && !selectedJillaId)
      newErrors.jilla = "Please select a Jilla.";

    if (selectedRole === "Arthiksakha" && !selectedArthiksakhasId)
      newErrors.arthiksakha = "Please select an Arthiksakha.";

    if (["Khand", "Sthan"].includes(selectedRole) && !selectedKhandId)
      newErrors.khand = "Please select a Khand.";

    if (selectedRole === "Sthan" && !selectedMandalamId)
      newErrors.mandalam = "Please select a Mandalam.";

    if (selectedRole === "Sthan" && !selectedSthanId)
      newErrors.sthan = "Please select a Sthan.";

    if (!name.trim())
      newErrors.name = "Name is required.";
    else if (!validName)
      newErrors.name = "Name must contain only letters and be at least 2 characters long.";

    if (!mobile.trim())
      newErrors.mobile = "Mobile number is required.";
    else if (!validMobile)
      newErrors.mobile = "Mobile number must be 10 digits.";

    // if (!responsibility.trim())
    //   newErrors.responsibility = "Responsibility is required.";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    let data; // <-- Declare here

    try {
      const levelIdMap = {
        Vibhag: selectedVibhagId,
        Jilla: selectedJillaId,
        Khand: selectedKhandId,
        Sthan: selectedSthanId,
        Arthiksakha: selectedArthiksakhasId,
      };

      data = JSON.stringify({
        role: selectedRole,
        level_id: levelIdMap[selectedRole],
        name,
        mobile,
        responsibility,
      });

      const response = await axiosPrivate.post(REGISTER_URL, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      showMessage("success", response?.data?.message);
      clearFields();
      setOtpData(response?.data);
      console.log(data); // ✅ Works now

    } catch (err) {
      console.log(data); // ✅ Works now

      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.data?.message) {
        const errorMsg =
          typeof err.response.data.message === "string"
            ? err.response.data.message
            : err.response.data.message.msg || "Unknown error";

        setErrMsg(errorMsg);
      } else {
        setErrMsg("Registration Failed");
      }

      errRef.current.focus();
    }
  };


  const showMessage = (type, message) => {
    if (type === 'error') {
      setErrMsg(message);
      setSucssMsg(""); // ensure success message is cleared
    } else if (type === 'success') {
      setSucssMsg(message);
      setErrMsg(""); // ensure error message is cleared
    }

    // Auto-hide after 10 seconds
    setTimeout(() => {
      setErrMsg("");
      setSucssMsg("");
    }, 10000); // 10000ms = 10 seconds
  };



  return (
    <>
      <Container>
        {/* {success ? (
          <section>
            <h1>User successfully registred !</h1>
            <div className="flexGrow">
              <button onClick={back}>Back</button>
            </div>
          </section>
        ) : ( */}

        <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
        <section className="userregbody">
          <p
            ref={errRef}
            className={errMsg ? "errmsg" : "offscreen"}
            aria-live="assertive"
          >
            {errMsg}
          </p>

          <p
            ref={errRef}
            className={sucssMsg ? "sucssmsg" : "offscreen"}
            aria-live="assertive"
          >
            {sucssMsg}
          </p>

          {otpData && (
            <div className="otp-info">
              <h4>OTP Details</h4>
              {/* <p><strong>Mobile:</strong> {otpData.mobile}</p> */}
              <p className="otp-big"><strong>OTP : {otpData.otp}</strong></p>
              <p className="otp-small"><strong>Expiry :</strong> {otpData.expiry}</p>
            </div>
          )}


          <div className="wrapper wrapper2 newraps">

            <form>
              <center><h4 class=" newraphead">Add User</h4></center>
              <Row>
                <Col md={6}>
                  <Form.Label className="newformstyle">Role</Form.Label>
                  <Form.Select
                    className="newselectstyle form-control guruselect"
                    value={selectedRole}
                    onChange={(e) => {
                      setSelectedRole(e.target.value);

                      setErrors((prev) => ({
                        ...prev,
                        role: "",
                      }));

                      // Optional
                      setSelectedPranthId(1);
                      setOtpData("");
                      // setSelectedSthan("");
                    }}
                  >
                    <option value="">-- Select Role --</option>
                    <option value="Vibhag">Vibhag</option>
                    <option value="Jilla">Jilla</option>
                    <option value="Khand">Khand</option>
                    <option value="Sthan">Sthan</option>
                    <option value="Arthiksakha">Arthiksakha</option>
                  </Form.Select>

                  {errors.role && (
                    <small className="text-danger d-block mt-1">
                      {errors.role}
                    </small>
                  )}
                </Col>
                {/* <Col md={6}>
                  <Form.Label className="newformstyle">Pranth</Form.Label>
                  <Form.Select
                    className="newselectstyle form-control guruselect"
                    value={selectedPranthId}
                    onChange={(e) => {
                      const pranthId = e.target.value;
                      setSelectedPranthId(pranthId);

                      if (!pranthId) {
                        // Clear vibhag, jilla, and table if no Pranth selected
                        setArthiksakhasList([]);
                        setSelectedArthiksakhasId("");

                        setKhandList([]);
                        setSelectedKhandId("");

                        setSthans([]);
                      }
                      setErrors((prev) => ({
                        ...prev,
                        pranth: ""
                      }));
                      setSelectedVibhagId("");
                    }}
                  >
                    <option value="">-- Select Pranth --</option>
                    {pranthList.map((p) => (
                      <option key={p.id} value={p.id}>
                        {p.name}
                      </option>
                    ))}
                  </Form.Select>

                  {errors.pranth && (
                    <small className="text-danger d-block mt-1">
                      {errors.pranth}
                    </small>
                  )}
                </Col> */}

                {selectedRole !== "Arthiksakha" && (
                  <Col md={6}>
                    <Form.Label className="newformstyle">Vibhag</Form.Label>
                    <Form.Select
                      className="newselectstyle form-control guruselect"
                      value={selectedVibhagId}
                      onChange={(e) => {
                        const vibhagId = e.target.value;
                        setSelectedVibhagId(vibhagId);

                        if (!vibhagId) {
                          // Clear Jilla list and selection if no Vibhag selected
                          setJillaList([]);
                          setSelectedJillaId("");
                          setSthans([]); // Optional: clear table too
                          setKhandList([]);
                          setSelectedKhandId("");
                        }


                        setErrors((prev) => ({
                          ...prev,
                          vibhag: ""
                        }));
                        setSelectedJillaId("");
                        setOtpData("");
                      }}
                      disabled={!selectedPranthId || !vibhagList.length}
                    >
                      <option value="">-- Select Vibhag --</option>
                      {Array.isArray(vibhagList) &&
                        vibhagList.map((v) => (
                          <option key={v.vibhag_id} value={v.vibhag_id}>
                            {v.vibhag_name}
                          </option>
                        ))}
                    </Form.Select>

                    {errors.vibhag && (
                      <small className="text-danger d-block mt-1">
                        {errors.vibhag}
                      </small>
                    )}
                  </Col>
                )}

                {["Jilla", "Khand", "Sthan"].includes(selectedRole) && (
                  <Col md={6}>
                    <Form.Label className="newformstyle">Jilla</Form.Label>
                    <Form.Select
                      className="newselectstyle form-control guruselect"
                      value={selectedJillaId}
                      onChange={(e) => {
                        const jillaId = e.target.value;
                        setSelectedJillaId(jillaId); // ✅ Just update state


                        if (!jillaId) {
                          setKhandList([]);
                          setSelectedKhandId("");
                          setSthans([]);
                        }


                        setErrors((prev) => ({
                          ...prev,
                          jilla: ""
                        }));
                        setSelectedKhandId("");
                        setOtpData("");
                      }}
                      disabled={!jillaList.length}
                    >
                      <option value="">-- Select Jilla --</option>
                      {jillaList.map((j) => (
                        <option key={j.jilla_id} value={j.jilla_id}>
                          {j.jilla_name}
                        </option>
                      ))}
                    </Form.Select>

                    {errors.jilla && (
                      <small className="text-danger d-block mt-1">
                        {errors.jilla}
                      </small>
                    )}
                  </Col>
                )}

                {selectedRole === "Arthiksakha" && (
                  <Col md={6}>
                    <Form.Label className="newformstyle">Arthiksakha</Form.Label>
                    <Form.Select
                      className="newselectstyle form-control guruselect"
                      value={selectedArthiksakhasId}
                      onChange={(e) => {
                        const ArthiksaId = e.target.value;
                        setSelectedArthiksakhasId(ArthiksaId);

                        setErrors((prev) => ({
                          ...prev,
                          arthiksakha: "",
                        }));
                        setOtpData("");
                      }}
                      disabled={!arthiksakhasList.length}
                    >
                      <option value="">-- Select Arthiksakhas --</option>
                      {Array.isArray(arthiksakhasList) &&
                        arthiksakhasList.map((v) => (
                          <option key={v.arthik_sakha_id} value={v.arthik_sakha_id}>
                            {v.arthik_sakha}
                          </option>
                        ))}
                    </Form.Select>
                    {errors.arthiksakha && (
                      <small className="text-danger d-block mt-1">
                        {errors.arthiksakha}
                      </small>
                    )}
                  </Col>
                )}


                {["Khand", "Sthan"].includes(selectedRole) && (
                  <Col md={6}>
                    <Form.Label className="newformstyle">Khand</Form.Label>
                    <Form.Select
                      className="newselectstyle form-control guruselect"
                      value={selectedKhandId}
                      onChange={(e) => {
                        setSelectedKhandId(e.target.value);

                        setErrors((prev) => ({
                          ...prev,
                          khand: "",
                        }));
                        setOtpData("");
                        setSelectedMandalamId("");
                      }}
                      disabled={!khandList.length}
                    >
                      <option value="">-- Select Khand --</option>
                      {khandList.map((k) => (
                        <option key={k.khand_id} value={k.khand_id}>
                          {k.khand_name}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.khand && (
                      <small className="text-danger d-block mt-1">
                        {errors.khand}
                      </small>
                    )}
                  </Col>
                )}

                {selectedRole === "Sthan" && (
                  <Col md={6}>
                    <Form.Label className="newformstyle">Mandalam</Form.Label>
                    <Form.Select
                      className="newselectstyle form-control guruselect"
                      value={selectedMandalamId}
                      onChange={(e) => {
                        const mandalamId = e.target.value;
                        setSelectedMandalamId(mandalamId); // Correctly set Mandalam ID

                        setErrors((prev) => ({
                          ...prev,
                          mandalam: "",
                        }));

                        setSelectedSthanId("");
                        setOtpData("");
                      }}
                      disabled={!mandalamList.length}
                    >

                      <option value="">-- Select Mandalam --</option>
                      {mandalamList.map((m) => (
                        <option key={m.mandal_id} value={m.mandal_id}>
                          {m.mandal_name}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.mandalam && (
                      <small className="text-danger d-block mt-1">
                        {errors.mandalam}
                      </small>
                    )}
                  </Col>
                )}


                {selectedRole === "Sthan" && (
                  <Col md={6}>
                    <Form.Label className="newformstyle">Sthan</Form.Label>
                    <Form.Select
                      className="newselectstyle form-control guruselect"
                      value={selectedSthanId}
                      onChange={(e) => {
                        const sthanId = e.target.value;
                        setSelectedSthanId(sthanId); // Correctly set Mandalam ID

                        setOtpData("");
                        setErrors((prev) => ({
                          ...prev,
                          sthan: "",
                        }));
                      }}

                      disabled={!sthanList.length}
                    >

                      <option value="">-- Select Sthan --</option>
                      {sthanList.map((m) => (
                        <option key={m.sthan_id} value={m.sthan_id}>
                          {m.sthan_name}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.sthan && (
                      <small className="text-danger d-block mt-1">
                        {errors.sthan}
                      </small>
                    )}
                  </Col>
                )}

                <Col md={6}>
                  <div className="input-box arthik_input-box"><br />
                    <input
                      type="text"
                      id="name"
                      className="newinpstyle"
                      placeholder="Enter Name"
                      autoComplete="off"
                      ref={userRef}
                      onChange={(e) => {
                        setName(e.target.value.replace(/[^a-zA-Z\s]/g, ""));
                        setOtpData("");
                        setErrors((prev) => ({
                          ...prev,
                          name: "",
                        }));
                      }}
                      value={name}
                      required
                      aria-invalid={validName ? "false" : "true"}
                      aria-describedby="namenote"
                    />


                  </div>
                  {errors.name && (
                    <small className="text-danger d-block mt-1">
                      {errors.name}
                    </small>
                  )}
                </Col>
                <Col md={6}>
                  <div className="input-box arthik_input-box"><br />
                    <input
                      type="text"
                      id="mobile"
                      className="newinpstyle"
                      placeholder="Enter Mobile number"
                      autoComplete="off"
                      ref={userRef}
                      onChange={(e) => {
                        setMobile(e.target.value.replace(/\D/g, ""));
                        setOtpData("");
                        setErrors((prev) => ({
                          ...prev,
                          mobile: "",
                        }));
                      }}
                      value={mobile}
                      required
                      aria-invalid={validMobile ? "false" : "true"}
                      aria-describedby="mobilenote"
                      maxLength={10}
                    />

                  </div>
                  {errors.mobile && (
                    <small className="text-danger d-block mt-1">
                      {errors.mobile}
                    </small>
                  )}
                </Col>
                <Col md={6}>
                  <div className="input-box arthik_input-box"><br />
                    <input
                      type="text"
                      id="responsibility"
                      className="newinpstyle"
                      placeholder="Enter Responsibility"
                      autoComplete="off"
                      onChange={(e) => setResponsibility(e.target.value)}
                      value={responsibility}
                      required
                      aria-describedby="responsibilitynote"
                      onFocus={() => setResponsibilityFocus(true)}
                      onBlur={() => setResponsibilityFocus(false)}
                    />
                  </div>
                </Col>
              </Row>
              <button
                type="button" // Important to prevent form submit
                className="btn"
                onClick={handleSubmit} // Call this for "Sign Up"

              >
                Create User
              </button>
            </form>

          </div>
        </section>
        {/* )} */}
      </Container>
    </>
  );
};

export default AdminAddUser;
